export default {
  getAuditLocalList: {
    url: "/mock/audit/local/list",
    method: "get",
    desc: "本地审计查询",
    topTips: true
  }
};
